<span [innerHTML]="rendered"></span>
